/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerStore from 'stores/ActionDrawerStore';
import DashboardStore from 'stores/DashboardStore';
import Loading from 'components/Loading/Loading';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type { CustomerAccount, DataSource } from 'models/CustomerAccounts';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import DeleteCustomerAccountError from './DeleteCustomerAccountError/DeleteCustomerAccountError';
import DeleteCustomerAccountSuccess from './DeleteCustomerAccountSuccess/DeleteCustomerAccountSuccess';

import styles from '../../../ActionDrawer.module.scss';

export type DeleteCustomerAccountProps = {
  formData: { account: CustomerAccount, dataSource: DataSource },
};

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
  dashboardStore: DashboardStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'dashboardStore')
@observer
export default class DeleteCustomerAccount extends ComponentWithInjectedProps<
  DeleteCustomerAccountProps,
  {},
  InjectedProps
> {
  componentDidMount() {
    const { actionDrawerStore, formData } = this.props;

    // Do work
    actionDrawerStore.removeCustomerAccount(formData.account, formData.dataSource);
  }

  render(): React.Element<*> {
    const { t, formData, actionDrawerStore } = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:customer_accounts.delete_customer_account')} />
          <DeleteCustomerAccountError />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      const { dashboardStore } = this.props;

      dashboardStore.removeDashboardFromLocal();

      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:customer_accounts.delete_customer_account')} />
          <DeleteCustomerAccountSuccess />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:customer_accounts.delete_customer_account')} />
      </div>
    );
  }
}
